export const colors = {
  primary: "#FFA500",
  secondary: "#111111",
  accent: "#ff3c00",
  danger: "#e74c3c",
  button: "#ff6a00",
  text: "white",
  sec_text: "#727272",
  filter: "#ff4d4f",
  submit: "#ff6a00",
  savedraft: "#e2e8f0",
  sendmessagebtn: "#1a73e8",
  background: "#f1f3f6",
  features: "#4a5bdc",
  privacybackground: "rgba(0, 0, 0, 0.45)",
  privacycontent: "#555",
  contactbackground: "rgba(13, 41, 80, 0.65)",
  contactsubtitle: "#5a6a7e",
  contactitem: "#5a6a7e",
  whatsapp: "#25D366",
  headerBg: "#111111",
  headerHeight: "88px",
  headerText: "#ffffff",
  cardBg: "#ffffff",
  textPrimary: "#0f172a",
  textMuted: "#64748b",
  border: "#e2e8f0",
  borderDark: "#2a2a2a",
  overlay: "rgba(0, 0, 0, 0.45)",
  shadowSm: "0 2px 8px rgba(0, 0, 0, 0.06)",
  shadowMd: "0 8px 24px rgba(0, 0, 0, 0.1)",
  shadowLg: "0 20px 50px rgba(0, 0, 0, 0.15)",
  radiusSm: "8px",
  radiusMd: "12px",
  radiusLg: "16px",
  radiusXl: "20px",
  transition: "0.25s cubic-bezier(0.4, 0, 0.2, 1)",
};
